<ng-container>
  <ep-delivery-point-list
    [isLoading]="isDeliveryPointsLoading$ | async"
    [radioButtonName]="radioButtonName"
    [deliveryPoints]="deliveryPoints$ | async"
    [selectedDeliveryPointControl]="deliveryPointControl"
    [hasDeleteButton]="hasDeleteButton"
    (onClickDeleteButton)="deleteDeliveryPoint($event)"
  ></ep-delivery-point-list>
</ng-container>


<button
  customButton
  expand="block"
  appearance="text"
  size="large"
  (click)="gotToCreateDeliveryPoint()"
>
  <svg-icon src="./assets/icons/plus-circle.svg"></svg-icon>
  <span>
     {{ "delivery_points.new_point" | translate }}
  </span>
</button>
